import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { jwtDecode } from "jwt-decode";

@Injectable({
  providedIn: "root",
})
export class FleetAuthGuard {
  constructor(private readonly router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const fleetToken = localStorage.getItem("fleet_token");
    if (fleetToken) {
      try {
        jwtDecode(fleetToken);
        return true;
      } catch (error) {
        console.error("Invalid fleet token:", error);
        return this.router.parseUrl("/auth/fleet-operator-login");
      }
    }
    return this.router.parseUrl("/auth/fleet-operator-login");
  }
}
